import { memo, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { SearchIcon } from '../../../components/Icons'
import { useDebounce } from '../../../hooks/useDebounce'

const SearchFilter: React.FC = memo(() => {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchPar = searchParams.get('s') || ''
  const [searchQuery, setSearchQuery] = useState(searchPar)
  const debouncedSearchQuery = useDebounce(searchQuery, 500)

  useEffect(() => {
    if (debouncedSearchQuery) {
      searchParams.set('s', debouncedSearchQuery)
    } else {
      searchParams.delete('s')
    }
    searchParams.delete('p')
    setSearchParams(searchParams)
  }, [debouncedSearchQuery])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value)
  }

  const handleClear = () => {
    setSearchQuery('')
    searchParams.delete('s')
    setSearchParams(searchParams)
  }

  useEffect(() => {
    if (searchPar !== searchQuery) {
      setSearchQuery(searchPar)
    }
  }, [searchPar])

  return (
    <div className="w-full">
      <div className="tc-mv-admin-search-wrapper">
        <input
          type="text"
          placeholder="Type to filter..."
          value={searchQuery}
          onChange={handleChange}
        />
        {searchQuery ? (
          <button
            className="text-white hover:opacity-100 opacity-60"
            onClick={handleClear}
          >
            <i className="fa-solid fa-xmark text-xl" />
          </button>
        ) : (
          <SearchIcon className="tc-mv-search-icon" />
        )}
      </div>
      <div className="tc-mv-admin-filter-label">Search all companions</div>
    </div>
  )
})

export { SearchFilter }
